import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorHandlerService } from '@y42/error-handling';
import { ToastService } from '@y42/toast';
import { delay, map, Observable, of, tap } from 'rxjs';
import { AuthStore } from '../state/auth.store';
import { TwoFactorHttpService } from './two-factor-http.service';

@Injectable({
  providedIn: 'root',
})
export class TwoFactorService {
  constructor(
    private readonly twoFactorHttpService: TwoFactorHttpService,
    private readonly authStore: AuthStore,
    private readonly router: Router,
    private readonly toastService: ToastService,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {}

  enable(code: string): Observable<void> {
    return this.twoFactorHttpService.enable(code).pipe(
      tap(() => {
        this.authStore.enableTwoFactor();
      }),
    );
  }

  disable(code: string): Observable<boolean> {
    return this.twoFactorHttpService.disable(code).pipe(
      tap(() => {
        this.authStore.disableTwoFactor();
        this.toastService.success('2FA disabled successfully. Signing out...');
      }),
      delay(1000),
      tap(() => {
        this.router.navigateByUrl('/logout');
      }),
      map(() => true),
      this.errorHandlerService.catchError('[TwoFactorService.disable]: could not disable 2fa', () => of(false), {
        toast: (error) => (error as Error).message || 'Could not disable 2fa',
      }),
    );
  }

  getState(userId: number): Observable<void> {
    return this.twoFactorHttpService.getState(userId).pipe(
      tap((twoFactor) => {
        this.authStore.setTwoFactor(twoFactor);
      }),
      map(() => undefined),
    );
  }
}
